module.exports = __webpack_public_path__ + "media/src/application/media/banner_img-d327afea1121cd380b1f8112a329c189.png";